"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LoadingButton_1 = __importDefault(require("@mui/lab/LoadingButton"));
var BravasLoading_1 = __importDefault(require("../BravasLoading"));
function LoadingBravasButton(_a) {
    var loading = _a.loading, variant = _a.variant, onClick = _a.onClick, type = _a.type, children = _a.children, rest = __rest(_a, ["loading", "variant", "onClick", "type", "children"]);
    return ((0, jsx_runtime_1.jsx)(LoadingButton_1.default, __assign({ type: type, onClick: onClick, variant: loading ? 'outlined' : variant, loading: loading, loadingIndicator: (0, jsx_runtime_1.jsx)(BravasLoading_1.default, { size: "25px" }) }, rest, { children: children })));
}
exports.default = LoadingBravasButton;
LoadingBravasButton.defaultProps = {
    loading: false,
    variant: 'text',
    onClick: function () { },
    type: undefined,
};
//# sourceMappingURL=LoadingBravasButton.js.map